// extracted by mini-css-extract-plugin
var _1 = "t2L9";
export { _1 as "svgIcon" }
